/**
 * Shared XML generation utilities for draw.io output.
 */

/** Escape text for XML attribute values */
export function esc(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

/** Sequential ID generator for mxCell IDs */
export class IdGen {
  private counter = 0;
  constructor(private prefix = 'c') {}

  next(): string {
    this.counter++;
    return `${this.prefix}${this.counter}`;
  }
}

/** Wrap cells array into a full mxfile XML document */
export function wrapMxfile(cells: string[]): string {
  return [
    '<mxfile>',
    '  <diagram id="ex-mermaid" name="Page-1">',
    '    <mxGraphModel dx="1422" dy="762" grid="1" gridSize="10" guides="1" ' +
      'tooltips="1" connect="1" arrows="1" fold="1" page="1" pageScale="1" ' +
      'pageWidth="1169" pageHeight="827" math="0" shadow="0">',
    '      <root>',
    '        <mxCell id="0" />',
    '        <mxCell id="1" parent="0" />',
    ...cells,
    '      </root>',
    '    </mxGraphModel>',
    '  </diagram>',
    '</mxfile>',
  ].join('\n');
}

/** Create a vertex mxCell XML string */
export function vertexCell(
  id: string,
  value: string,
  style: string,
  parent: string,
  x: number,
  y: number,
  width: number,
  height: number,
): string {
  return (
    `        <mxCell id="${id}" value="${esc(value)}" ` +
    `style="${style}" vertex="1" parent="${parent}">\n` +
    `          <mxGeometry x="${x}" y="${y}" ` +
    `width="${width}" height="${height}" as="geometry" />\n` +
    `        </mxCell>`
  );
}

/** Create an edge mxCell XML string, optionally with waypoints */
export function edgeCell(
  id: string,
  value: string,
  style: string,
  parent: string,
  source: string,
  target: string,
  routePoints?: Array<{ x: number; y: number }>,
): string {
  if (routePoints && routePoints.length > 0) {
    const pointsXml = routePoints
      .map((p) => `              <mxPoint x="${Math.round(p.x)}" y="${Math.round(p.y)}" />`)
      .join('\n');
    return (
      `        <mxCell id="${id}" value="${esc(value)}" ` +
      `style="${style}" edge="1" parent="${parent}" ` +
      `source="${source}" target="${target}">\n` +
      `          <mxGeometry relative="1" as="geometry">\n` +
      `            <Array as="points">\n` +
      pointsXml + '\n' +
      `            </Array>\n` +
      `          </mxGeometry>\n` +
      `        </mxCell>`
    );
  }
  return (
    `        <mxCell id="${id}" value="${esc(value)}" ` +
    `style="${style}" edge="1" parent="${parent}" ` +
    `source="${source}" target="${target}">\n` +
    `          <mxGeometry relative="1" as="geometry" />\n` +
    `        </mxCell>`
  );
}

/** Create an edge label mxCell XML string */
export function labelCell(id: string, value: string, parent: string): string {
  return (
    `        <mxCell id="${id}" value="${esc(value)}" ` +
    `style="edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];" ` +
    `vertex="1" connectable="0" parent="${parent}">\n` +
    `          <mxGeometry relative="1" as="geometry"><mxPoint as="offset" /></mxGeometry>\n` +
    `        </mxCell>`
  );
}
